module.exports = __webpack_public_path__ + "static/media/viewed-icon.14a55671.svg";